import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function isEqualTo(formField: FormControl): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const areNotEquals = !control.value === formField.value;
    return areNotEquals ? { equalTo: { value: control.value } } : null;
  };
}
